import React from "react";
import ReactTooltip from "react-tooltip";

const FreeDownload = ({
  downloadPercentage,
  file,
  downloadsDisabled,
  onDownloadVideoClick,
  downloadVideoToolTip,
}) => {
  return (
    <>
      <div
        className={
          "share-item " +
          ((downloadPercentage > 0 && downloadPercentage !== 100) ||
          (file.switches &&
            file.switches.downloadeble.selected === "disabled") ||
          file.downloadPrice > 0 ||
          downloadsDisabled
            ? "d-none"
            : "")
        }
        onClick={onDownloadVideoClick}
        data-tip
        data-for="downloadVideo"
      >
        <i
          className={
            "fas text-white " +
            (downloadPercentage === 100 ? "fa-check" : "fa-download")
          }
        ></i>
        <ReactTooltip id="downloadVideo" type="dark" effect="solid">
          <span>{downloadVideoToolTip}</span>
        </ReactTooltip>
      </div>
    </>
  );
};
export default FreeDownload;
